<template>
  <div class="flex flex-col" :class="size">
    <slot name="label">
      <label :for="props.name" :class="props.classes">{{ label }}</label>
    </slot>
    <slot>
      <MultiSelect
        name="tagFilter"
        v-model="value"
        :options="options"
        :option-label
        :placeholder
        class="h-10"
        :class="inputClass"
        display="chip"
        filter
        overlayClass="text-sm"
        :scrollHeight
        :disabled
        pt:option:class="py-1"
        pt:pcfilter:class="py-0"
        :maxSelectedLabels="maxLabels"
        @change="$emit('change')"
      ></MultiSelect>
    </slot>
  </div>
</template>

<script setup lang="ts">
interface Props {
  name: string;
  value?: string;
  label: string;
  size?: string;
  classes?: string;
  options: any[];
  optionLabel: string | ((data: any) => string);
  placeholder?: string;
  disabled?: boolean;
  scrollHeight?: string;
  inputClass?: string;
  maxLabels?: number;
}
const props = withDefaults(defineProps<Props>(), {
  size: "w-full",
  classes: "font-bold",
  placeholder: "",
  disabled: false,
  scrollHeight: "30rem",
  inputClass: "",
  maxLabels: 2,
});

const emit = defineEmits<{
  change: [];
}>();

const value = defineModel<Object[]>({ required: true });
</script>
